import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface AppointmentWithScheduleType {
  scheduleType?: ScheduleType | null;
  date: string | null;
}

export function prioritizeUnscheduledFlexAppointments<T extends AppointmentWithScheduleType>(
  appointments: T[],
): T[] {
  return [...appointments].sort((a, b) => {
    const aIsFlexWithoutDate = a.scheduleType === ScheduleType.FLEX && !a.date;
    const bIsFlexWithoutDate = b.scheduleType === ScheduleType.FLEX && !b.date;

    if (aIsFlexWithoutDate && !bIsFlexWithoutDate) {
      return -1;
    }
    if (!aIsFlexWithoutDate && bIsFlexWithoutDate) {
      return 1;
    }
    return 0;
  });
}
